import { MutableRefObject, RefObject, useLayoutEffect } from "react";

export type PolyLineObject = {
    id: string,
    visible: boolean,
    strokeColor: string,
    strokeOpacity: number,
    strokeWeight: number,
    routeData: google.maps.LatLngLiteral[],
};

export const usePolyline = (
    googleMapRef: RefObject<google.maps.Map>,
    polylinesRef: MutableRefObject<{ [keys: string]: google.maps.Polyline }>,
    polyLines?: PolyLineObject[],
) => {
    useLayoutEffect(() => {
        if (googleMapRef.current && polyLines) {
            // If the poly line is removed from the list , delete it on the map
            Object.keys(polylinesRef.current).forEach((oldID) => {
                if (!polyLines.find(({ id }) => id === oldID)) {
                    polylinesRef.current[oldID]?.setMap(null);
                    delete polylinesRef.current[oldID];
                }
            });

            // otherwise go through the current polylines and either create a new one
            // if a polyline is added
            // or update the polyline
            polyLines.forEach(({ routeData, id, ...polyLineOptions }) => {
                if (polylinesRef.current[id]) {
                    polylinesRef.current[id].setOptions({
                        path: routeData,
                        ...polyLineOptions,
                    });
                } else {
                    const polyLineObject = new google.maps.Polyline({
                        path: routeData,
                        geodesic: true,
                        ...polyLineOptions,
                    });
                    polyLineObject.setMap(googleMapRef.current);
                    polylinesRef.current[id] = polyLineObject;
                }
            });
        }
    }, [polyLines]);
};
